"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var hasValue_1 = __importDefault(require("./hasValue"));
// Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.
function isFilled(obj, SSR) {
    if (SSR === void 0) { SSR = false; }
    return (obj &&
        (((0, hasValue_1.default)(obj.value) && obj.value !== '') ||
            (SSR && (0, hasValue_1.default)(obj.defaultValue) && obj.defaultValue !== '')));
}
exports.default = isFilled;
//# sourceMappingURL=isFilled.js.map